import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import NavbarGuest from "./NavbarGuest";
import Footer from "./Footer";
import axios from "../api/axios";

export default function VerifyEmailNotice() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [verified, setVerified] = useState(null);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const verifyEmail = async () => {
      if(!token){
        setVerified(false);
        setMessage("Invalid verification link.");
        return;
      }

      try {
        const response = await axios.get(
          '/email/verify', { params: {token} }
        );

        const data = response.data;

        if (data.success) {
          setVerified(true);
          setMessage(data.message || "Email verified successfully.");
        } else {
          setVerified(false);
          setMessage(
            data.message ||
              "Unexpected error occurred while verifying email."
          );
        }
      } catch (error) {
        setVerified(false);

        if (error.response?.data?.message) {
          setMessage(error.response.data.message);
        } else {
          setMessage("Verification link is invalid or expired.");
        }
      }
    };

    verifyEmail();
  }, []);

  return (
    <section className="fullScreenLayout">
      <NavbarGuest />
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ padding: "20px", flex: "1" }}
      >
        <div style={{ padding: "3rem 1.5rem", maxWidth: "400px" }}>
          {verified === null ? (
            <>
              <h2 className="text-center login">Verifying your email...</h2>
              <p className="text-center para">
                Please wait while we verify your email.
              </p>
            </>
          ) : verified === true ? (
            <>
            <h2 className="text-center login">Verified successfully</h2>
            <p className="text-center para success-text" >
              {message}
            </p>
            <p className="text-center mt-2">
              You can now <Link to="/login">log in</Link>.
              </p>
            </>
          ) : (
            <>
            <h2 className="text-center login">Verification Failed</h2>
            <p className="text-center para error-text" >
              {message}
              </p>
            <p className="text-center mt-2">
              Please contact <a href="mailto:support@cibermed.com">support@cibermed.com</a> for a new verification link.
            </p>
            </>
          )}
        </div>
      </div>

      <Footer />
    </section>
  );
}